module.exports = __webpack_public_path__ + "Roboto-BlackItalic.256aab654d3c4dd0e12f.ttf";


//////////////////
// WEBPACK FOOTER
// ./~/@c4/assets/src/assets/fonts/roboto/Roboto-BlackItalic.ttf
// module id = 380
// module chunks = 2